import SplashPageView from 'src/pages/SplashPage/view'
import React, { useEffect } from 'react'
import { MajorNoticeSpace as mnspace, VersionCheckSpace as vcspace } from 'src/types/api'
import { ERRCODE_SUCCESS } from 'src/service/constant/errcodes'
import { useModal } from 'src/provider/ModalContextProvider'
import {
  majorNoticeQueryOption,
  sessionCheckQueryOption,
  useCustomMutation,
  versionCheckQueryOption,
} from 'src/hooks/react-query/useCustomMutation.hook'
import usePageNav from 'src/hooks/usePageNav.hook'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { Bridge } from 'src/utils/bridge'
import SplashNotiModal from 'src/components/common/Modal/children/SplashNotiModal'
import usePageVisibility from 'src/hooks/usePageVisibility.hook'
import { useCookies } from 'react-cookie'
import { DateUtils } from 'src/utils/date'
import { useGlobalStore } from 'src/store/zustand'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import useLoginDetector from 'src/hooks/useLoginDetector.hook'
import useUserInfo from 'src/hooks/useUserInfo'

//Step: 앱 알림 권한 요청=> 버전 체크 => 필수 공지 사항 체크
const SplashPage = () => {
  const originURL = window.location.origin
  const [, setCookie] = useCookies([
    'error_message',
    'pin_check',
    'auth-key',
    'u-tel',
    'app_install_popup',
  ])
  const { openModal } = useModal()
  const { channel, web } = useChannel()
  const { mainPageNav, introPageNav, addUtmParameter } = usePageNav()
  const { c_tel } = useCustomCookies()
  const { cookieNonePinCheckTime } = DateUtils
  const { setIsCheckAppInfo } = useGlobalStore()
  const { isLogin: isCookieLogin } = useLoginDetector()
  const { generateSession } = useUserInfo()

  const { mutateAsync: noticeCheckMutate } = useCustomMutation<mnspace.Request, mnspace.Response>(
    majorNoticeQueryOption(),
  )
  const { mutateAsync: versionCheckMutate } = useCustomMutation<vcspace.Request, vcspace.Response>(
    versionCheckQueryOption(),
  )
  const { mutateAsync: sessionCheckMutate } = useCustomMutation<unknown, unknown>(
    sessionCheckQueryOption(),
  )

  const handleVersionVerify = (appVersion: string, isLogin: boolean) => {
    versionCheckMutate({ Version: appVersion }).then(({ Header, Body }) => {
      const { URL } = Body

      if (Header.ErrCode === ERRCODE_SUCCESS) {
        setIsCheckAppInfo(true)
        handleNotificationStatus(isLogin)
      } else {
        const openAppStore = () => Bridge.handleReqExternalOpenUrl(URL)
        const closeApp = () => Bridge.handleReqAppClose()

        const t = '필수 업데이트'
        const d = '서비스 안정성을 위해 업데이트가 필요합니다. 업데이트 후 이용 부탁 드립니다.'
        const button_cancel = { t: '앱 종료', f: closeApp }
        const button_submit = { t: '업데이트', f: openAppStore }
        openModal({
          contents: { t, d },
          button: { cancel: button_cancel, submit: button_submit },
        })
      }
    })
  }

  const handleNotificationStatus = (isLogin: boolean) => {
    noticeCheckMutate({}).then(({ Header, Body }) => {
      const { Contents, Title, Type } = Body
      //시스템 점검 및 공지
      if (Type === 1) {
        window.location.replace(`${window.location.origin}/${channel}/system_notice`)
      } else if (Header.ErrCode === ERRCODE_SUCCESS && Contents === '') {
        isLogin ? mainPageNav() : introPageNav()
      } else {
        openModal({
          contents: { t: Title, children: <SplashNotiModal contents={Contents} /> },
          button: {
            submit: { t: '확인', f: () => (isLogin ? mainPageNav() : introPageNav()) },
          },
        })
      }
    })
  }

  const handleIsLogin = (isLogin: boolean, pNumber?: string) => {
    Bridge.handleWebViewStartUrl(
      originURL + addUtmParameter(isLogin ? '/main' : '/intro'),
      pNumber ?? '',
    )
    setCookie('pin_check', true, { path: '/', expires: cookieNonePinCheckTime() })
    if (web) {
      handleNotificationStatus(isLogin)
    } else {
      Bridge.getAppInfo.req((appVersion) => handleVersionVerify(appVersion, isLogin))
      // //ios는 응답을 따로 받아야해서 여기서 처리
      Bridge.getAppInfo.res((appVersion) => handleVersionVerify(appVersion, isLogin))
    }
  }

  const handleMountSplash = () => {
    if (isCookieLogin) {
      // 서버 세션 확인
      sessionCheckMutate({}).then(({ Header }) => {
        const isAlive = Header.ErrCode === ERRCODE_SUCCESS
        handleIsLogin(isAlive, isAlive ? c_tel : undefined)
      })
      return
    }
    if (web) {
      handleIsLogin(false)
      return
    }
    // u-tel 없음 → 앱 저장값으로만 autologin 시도
    generateSession().then((pNumber) => {
      handleIsLogin(!!pNumber, pNumber || undefined)
    })
  }

  usePageVisibility((isForeground: boolean) => {
    isForeground && handleMountSplash()
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(handleMountSplash, [])

  return <SplashPageView />
}

export default SplashPage
